import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { ContractSettlementOverviewPage } from "@/features/contracts/contract-settlement-overview-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia/$id")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.szablony",
			location.pathname,
		);
	},
	component: ContractSettlementRoute,
});

function ContractSettlementRoute() {
	const { id } = Route.useParams();
	const pathname = useLocation({ select: (location) => location.pathname });
	const detailPath = `/kontrakty/rozliczenia/${id}`;

	if (pathname === detailPath || pathname === `${detailPath}/`) {
		return <ContractSettlementOverviewPage />;
	}

	return <Outlet />;
}
